import React, {Component} from 'react';

import {ClientConfigurationContent} from "./ClientConfigurationContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientConfiguration extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulClientIntegrationsSubmit = this.afterSuccessfulClientIntegrationsSubmit.bind(this);
    }

    afterSuccessfulClientIntegrationsSubmit(data) {
        alert("Se ha actualizado la información con éxito")
    }

    render() {
        return (
            <ClientConfigurationContent clientId={this.props.match.params.id}
                                        afterSuccessfulClientIntegrationsSubmit={this.afterSuccessfulClientIntegrationsSubmit}
            />
        )
    }
}

export default withRouterParams(ClientConfiguration);
